import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Common, color } from '@stockbit/ui';

import SearchCompany from 'global/TradingModal/components/SearchCompany';
import slice, {
  selectors,
} from 'global/TradingModal/components/SearchCompany/slice';
import useSearchCompanyModalStore from 'global/Securities/stores/useSearchCompanyModalStore';
import { useBondsModalStore } from 'global/TradingModal/RealTradingModal/ModalBonds/stores/useBondsModalStore';

import useBondsAnalytics from 'global/TradingModal/RealTradingModal/ModalBonds/useBondsAnalytics';
import { useFliptBoolean } from 'lib/flipt/hooks';
import { FeatureFlagKeys } from 'lib/flipt/constants/flagKeys';
import {
  FullScreenContainer,
  SearchCompanyWrapper,
  ConfirmButton,
  Iconmoon,
} from './styled';

const { Flex, Text } = Common;

function SearchCompanySymbol({ onSymbolChange }) {
  const dispatch = useDispatch();
  const { result } = useSelector(selectors);
  const stockInputRef = useRef<HTMLInputElement>();

  const isFREligible = useFliptBoolean(FeatureFlagKeys.FR_BONDS);
  const { FRBondActionTrackers } = useBondsAnalytics();
  const openBondsBuy = useBondsModalStore((s) => s.openBuyModal);
  const closeSearchCompanyModal = useSearchCompanyModalStore(
    (s) => s.closeModal,
  );

  const isSuggestionEmpty = !result?.length || result?.length < 1;

  const onClose = async () => {
    dispatch(slice.actions.resetResult());
    closeSearchCompanyModal();
  };

  const handleOpenTransaction = (symbol: string, type: string) => {
    if (type === 'fr' && !isFREligible) {
      // do nothing, if not eligible to use FR
      return;
    }

    if (type === 'fr') {
      openBondsBuy(symbol);
      FRBondActionTrackers.onOrderButtonClicked(
        'Buy',
        symbol,
        'Search Company Page',
      );
    } else {
      onSymbolChange(symbol);
    }

    onClose();
  };

  const handleConfirm = () => {
    if (isSuggestionEmpty) {
      return;
    }

    const [selected] = result;
    if (!selected) {
      return;
    }
    handleOpenTransaction(selected.name, selected.type);
  };

  const onClickResult = (symbol: string) => {
    if (isSuggestionEmpty) {
      return;
    }

    const item = result.find((el) => el.name === symbol);
    if (!item) {
      return;
    }

    handleOpenTransaction(item.name, item.type);
  };

  useEffect(() => {
    stockInputRef.current?.focus();
  }, []);

  return (
    <FullScreenContainer>
      <SearchCompanyWrapper>
        <Flex justify="space-between" align="center">
          <Text size="26px" color={color.primary}>
            Type symbol to buy
          </Text>
          <Iconmoon
            size="16px"
            color={color.nightRider}
            className="icon-trading_xbold"
            onClick={onClose}
          />
        </Flex>
        <SearchCompany
          ref={stockInputRef}
          isInTradingModal={false}
          updateSymbol={onClickResult}
        />
        <Flex align="center" justify="flex-end" padding="10px" mt="5px">
          <Text padding="10px" color={color.nobel}>
            Press Enter or
          </Text>
          <ConfirmButton disabled={isSuggestionEmpty} onClick={handleConfirm}>
            CONFIRM
          </ConfirmButton>
        </Flex>
      </SearchCompanyWrapper>
    </FullScreenContainer>
  );
}

export default SearchCompanySymbol;
